import { css } from 'linaria';

export const designRegistrationPanelSection = css`
  @media (--from-desktop) {
    min-height: 60px;
  }
`;

export const stickyBanner = css`
  background-color: var(--background-accent);
  transition: all 0.5s;
`;

export const hiddenStickyBanner = css`
  @media (--from-tablet) {
    display: none;
  }
`;

export const fixedClassName = css`
  &&&& {
    @media (--to-desktop) {
      top: unset;
      position: relative;
    }
  }
`;

export const stickyBannerWrapper = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-top: 24px;
  padding-bottom: 24px;
  transition: all 0.4s ease;

  @media (--to-desktop) {
    flex-direction: column;
  }
`;

export const fixedBannerWrapper = css`
  @media (--from-desktop) {
    padding-top: 8px;
    padding-bottom: 8px;
  }
`;

export const flexRowBannerWrapper = css`
  @media (--only-tablet) {
    flex-direction: row;
  }
`;

export const textBlock = css`
  display: flex;
  align-items: center;
  width: 460px;

  @media (--to-desktop) {
    width: 100%;
    margin-bottom: 24px;
  }

  @media (--only-mobile) {
    flex-direction: column;
    align-items: baseline;
  }
`;

export const fixedTextBlock = css`
  width: 100%;

  @media (--from-desktop) {
    margin-right: 16px;
  }
`;

export const newTextBlock = css`
  @media (--only-tablet) {
    margin-bottom: 0;
  }
`;

export const bannerIcon = css`
  && {
    width: 64px;
    height: 64px;

    @media (--from-tablet) {
      margin-right: 24px;
    }

    @media (--only-mobile) {
      margin-bottom: 16px;
    }
  }
`;

export const hiddenBannerIcon = css`
  @media (--to-desktop) {
    display: none;
  }
`;

export const fixedBannerIcon = css`
  && {
    @media (--from-desktop) {
      width: 40px;
      height: 40px;
      margin-right: 34px;
    }
  }
`;

export const stickyBannerDescription = css`
  width: 372px;

  @media (--only-mobile) {
    width: 100%;
  }
`;

export const fixedStickyBannerDescription = css`
  && {
    @media (--from-desktop) {
      width: 100%;
      font-size: 14px;
      line-height: 18px;
    }
  }
`;

export const newstickyBannerDescription = css`
  @media (--only-tablet) {
    width: 308px;
  }
`;

export const stickyBannerActionWrapper = css`
  display: flex;
  flex-direction: row;
  column-gap: 24px;

  @media (--only-tablet) {
    justify-content: flex-end;
    width: 100%;
  }

  @media (--only-mobile) {
    row-gap: 8px;
    flex-direction: column-reverse;
    width: 100%;
  }
`;

export const fixedButton = css`
  && {
    && {
      @media (--from-desktop) {
        padding: 8px 18px;
        font-size: 14px;
        line-height: 20px;
      }
    }
  }
`;
